
import {defineComponent} from "vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {CatalogProductsRestService} from "@/services/rest/cpc-mgmt/CatalogProductsRestService";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import ProductDetailPricesTab from "@/components/layouts/catalog/product-detail/ProductDetailPricesTab.vue";
import {handleSavedSuccessfully} from "@/helpers/toast-helper";
import ProductDetailCategoriesTab from "@/components/layouts/catalog/product-detail/ProductDetailCategoriesTab.vue";
import ProductDetailPhotosTab from "@/components/layouts/catalog/product-detail/ProductDetailPhotosTab.vue";
import ProductDetailPimTab from "@/components/layouts/catalog/product-detail/ProductDetailPimTab.vue";
import ProductDetailStockTab from "@/components/layouts/catalog/product-detail/ProductDetailStockTab.vue";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import ProductDetailCustomerProductTab
  from "@/components/layouts/catalog/product-detail/ProductDetailCustomerProductTab.vue";
import CategoryWithParents from "@/components/layouts/catalog/CategoryWithParents.vue";
import {Tooltip} from "bootstrap";
import {StandardPriceSourceEnum} from "@/api/enums/standard-price-source-enum";
import {
  CatalogProductWithImageDetailRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageDetailRestDtoModel";

export default defineComponent({
  name: "CatalogProductDetail",
  components: {
    CategoryWithParents,
    CatalogBuildStatus,
    AlertError2,
    BaseTitle,
    ProductDetailCustomerProductTab,
    ProductDetailPricesTab,
    ProductDetailCategoriesTab,
    ProductDetailPhotosTab,
    ProductDetailPimTab,
    ProductDetailStockTab,
  },
  data() {
    return {
      returnRoute: {name: 'catalog-products-overview'} as object,
      product_code: this.$route.params.product_code as string,
      productDetailUI: UIStateDto.createWithDefaults(),

      product: CatalogProductWithImageDetailRestDtoModel.createWithDefaults(),

      currentComponent: 'product-detail-dummy-tab' as string,
      currentDisplayedComponent: 'product-detail-dummy-tab' as string,
    }
  },
  async mounted() {
    await this.reloadContent();
    this.setCurrentComponent('product-detail-prices-tab');
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      new Tooltip(el as Element);
    });
  },
  computed: {
    currentProperties(): object {
      return {
        "product-code" : this.product.product.product_code,
        "cnk-code" : this.product.product.product_info.cnk_code
      };
    },
    productPrice(): number | null{
      if (this.product.product.product_price.standard_price_source_code === StandardPriceSourceEnum.NO_PRICE_AVAILABLE) {
        return null;
      }
      return this.product.product.product_price.sale_price_with_vat;
    },
    priceClass(): string | null {
      if (!this.product.product.product_price.standard_price_source_code) {
        return null;
      }
      if ([
        StandardPriceSourceEnum.DP_REFERENCE,
        StandardPriceSourceEnum.DP_REFERENCE_MODIFIED
      ].includes(this.product.product.product_price.standard_price_source_code)) {
        return 'dashed-underline fst-italic';
      }
      return null;
    },
    tooltip(): string | null {
      if (!this.product.product.product_price.standard_price_source_code) {
        return null;
      }
      if (this.product.product.product_price.standard_price_source_code === StandardPriceSourceEnum.NO_PRICE_AVAILABLE) {
        return this.$t('noPriceAvailable');
      }
      if ([
        StandardPriceSourceEnum.DP_REFERENCE,
        StandardPriceSourceEnum.DP_REFERENCE_MODIFIED
      ].includes(this.product.product.product_price.standard_price_source_code)) {
        return this.$t('thisIsAReferencePrice');
      }
      return null;
    },
  },
  methods: {
    async reloadContent() {
      this.productDetailUI
        .setNotReady()
        .clearError();

      try {
        this.product = await CatalogProductsRestService.getInstance()
          .getCatalogProductDetail(this.product_code, this.$i18n.locale);
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.productDetailUI.setReady();
      }
    },
    handleSavedSuccessfully,
    setCurrentComponent(cmp: string) {
      if (this.product.product.product_source_code === 'CUSTOMER' && cmp !== 'product-detail-photos-tab') {
        // Detail scherm ondersteunt momenteel geen eigen producten
        this.currentComponent = cmp;
        this.currentDisplayedComponent = 'product-detail-customer-product-tab';
      } else {
        this.currentComponent = cmp;
        this.currentDisplayedComponent = cmp;
      }
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.productDetailUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.productDetailUI as UIStateDto))
        .catch(exceptions, true);
    }
  },
});
